import { useContext, useEffect } from 'react';
import { Box, Grid, Paper, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { DataDispatchContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsPage, analyticsDomain, analyticsCta } from '../../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../../common/util/util'

export default function SystemError() {
  const navigate = useNavigate()
  const dispatch: any = useContext(DataDispatchContext)
  useEffect(()=>{
    sendViewAnalytics('/dashboard', {
            domain: analyticsDomain.dashboard,
            name: analyticsPage.fullscreenError
          })
  },[])

  function handleContactUs() {
    dispatch({
      type: 'setAcctSelected',
      acctSelected: 'help'
    })
    sendClickAnalytics('/dashboard', {
      domain: analyticsDomain.dashboard,
      name: analyticsCta.systemErrorContactUs,
      metadata: {},
    })
    navigate('/profile')
  }
  return (
    <Grid container id="systemErrorContent" 
    direction="row" display="flex"  
    justifyContent="flex-end" 
    spacing={custom.spacing.xxs}
    width= "100%">
      <Paper id="systemError" elevation={0} 
            sx={{ 
              borderRadius: custom.corners5, 
              border: custom.border,
              width: "100%",
              backgroundColor: 'sz.colors.surfaceAccent',
              my: custom.spacing.md,
              ml: custom.spacing.sm,
              p: custom.spacing.md,
            }}
        >
          <Box component="img"
                src="images/systemError.svg"
              />  
          <Typography component="p" mt={custom.spacing.xxs}
              variant="szHeading.Bold.Medium">
              System error
          </Typography>
          <Box>
            <Typography component="p" mt={custom.spacing.xxs}
                variant="szBody.Regular.Medium">
                We've encountered an issue fetching your data. This happens for unexpected reasons – your best bet is to restart the SolarZero App. If you’re still having issues, please contact customer care.
            </Typography>
          </Box>
          <Button variant="contained" id="contactUsButton"
              onClick={handleContactUs}
              sx={{ mt: custom.spacing.sm, 
                px: custom.spacing.sm, 
                py: custom.spacing.xs }}>
            <Typography variant="szBody.Regular.Medium"
                color="#FFF">
                Contact us
            </Typography>
          </Button>
      </Paper>
    </Grid>
  )
}
